import { Flex, styled } from '@project44/manifest-ds';

import { scopedT } from '../../../../utils/helpers/scopedT';

const t = scopedT();

interface SeeMoreProps {
  count: number;
}

const StyledFlex = styled(Flex, {
  padding: '$small',
  background: '$background-secondary',
  borderRadius: '$full',
  fontSize: '$small',
  color: '$text-secondary',
  height: '24px',
});

const SeeMore = ({ count }: SeeMoreProps) => {
  return (
    <StyledFlex align="center" data-testid="see-more">
      {t('plusNMore', { number: count })}
    </StyledFlex>
  );
};

export default SeeMore;
